import { c as _c } from "react/compiler-runtime";
import { SphereActionDivider } from "@components/common/sphere-action-divider";
import { Box } from "@mui-wrapper";
import { getProjectByIdSelector } from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";
import { shouldHideOpenProject } from "@utils/project-utils";
import { ProjectOptionsMenu } from "@components/project/project-options-menu";
import { ProjectOpenButton } from "@components/project/project-open-button";

/** Determines the context or places where the the ProjectActions component can be used */

/** Project actions buttons */
export function ProjectActions(t0) {
  const $ = _c(19);
  const {
    project,
    contextType,
    extraMenuItems
  } = t0;
  let t1;
  if ($[0] !== project.id) {
    t1 = getProjectByIdSelector(project.id);
    $[0] = project.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sdbProject = useAppSelector(t1);
  let t2;
  if ($[2] !== sdbProject) {
    t2 = shouldHideOpenProject(sdbProject);
    $[2] = sdbProject;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const shouldShowOpenProjectButton = !t2;
  const shouldShowDivider = shouldShowOpenProjectButton && sdbProject !== null;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "flex",
      alignItems: "center"
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== contextType || $[6] !== sdbProject || $[7] !== shouldShowOpenProjectButton) {
    t4 = sdbProject !== null && shouldShowOpenProjectButton && <ProjectOpenButton project={sdbProject} contextType={contextType} />;
    $[5] = contextType;
    $[6] = sdbProject;
    $[7] = shouldShowOpenProjectButton;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== shouldShowDivider) {
    t5 = shouldShowDivider && <SphereActionDivider />;
    $[9] = shouldShowDivider;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== contextType || $[12] !== extraMenuItems || $[13] !== sdbProject) {
    t6 = sdbProject !== null && <ProjectOptionsMenu project={sdbProject} contextType={contextType} extraMenuItems={extraMenuItems} />;
    $[11] = contextType;
    $[12] = extraMenuItems;
    $[13] = sdbProject;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = <Box component="div" sx={t3}>{t4}{t5}{t6}</Box>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}